import { useCallback } from "react";

import { UseMutationOptions } from "@tanstack/react-query/src/types";
import { castArray } from "lodash/fp";

import { ProgressItemEnum } from "@app/analytics/GettingStarted/types";
import useUserMetadata from "@app/common/auth/useUserMetadata";
import { UserMetadata } from "@app/common/types";

const useCompleteGettingStarted = () => {
  const { userMetadata, updateUserMetadata } = useUserMetadata();
  const progress = userMetadata?.onboardingChecklistProgress ?? 0;
  const completeChecklistItem = useCallback(
    (
      progressEnum: ProgressItemEnum | ProgressItemEnum[],
      options: UseMutationOptions<void, Error, Partial<UserMetadata>> = {}
    ) => {
      const newProgress = castArray(progressEnum).reduce(
        (acc, item) => acc | item,
        progress
      );
      updateUserMetadata.mutate(
        {
          onboardingChecklistProgress: newProgress,
        },
        options
      );
    },
    [progress]
  );

  return {
    mutate: completeChecklistItem,
    isPending: updateUserMetadata.isPending,
    isSuccess: updateUserMetadata.isSuccess,
  };
};

export default useCompleteGettingStarted;
